/* ============================================================
   luxe-gift-guide.js
   The gift finder on the gift guide page - Big Q4 Update [#07a], 2026-11-02.
   Loaded deferred by sections/luxe-gift-guide.liquid and, since 3 Nov 2026 ([#28]), by the
   homepage section sections/luxe-gift-finder.liquid (markup: snippets/luxe-gift-finder.liquid).
   Vanilla, no dependencies, no network calls: it matches over the [data-luxe-gg-item] cards inside
   the root's [data-luxe-gg-grid]. On the gift guide that is the visible product grid; on the
   homepage it is a hidden pool of the collection's cards rendered for this purpose.

   Each grid item ([data-luxe-gg-item]) carries:
     data-gift-for  "her him me" (from tags gift-her / gift-him / gift-me)
     data-gift-cat  "ipl oral skin grooming" (from tags cat-*)
     data-price     min price in cents (visitor's currency)
     data-set       "true" for value sets (tag value-set, and the injected set cards)
     data-rating    Loox average, 0 when none
     data-title / data-url / data-img / data-price-label / data-worth-label (for the set row)

   Pick (Dan's spec, 2 Nov 2026):
     1. not a set, who matches, category matches (Surprise me = any), price in the budget;
     2. if fewer than two: add products in the budget only;
     3. if still fewer than two: add the best sellers (the grid's own order).
   Ranked by rating (high first), then price (low first), then grid order. Two picks.
   The set: a value set for the same person and category, else for the same person, else
   any value set, else no set row.
   An unanswered question counts as "any".

   Without this script the questions still show and the button submits a GET form whose
   action is the grid anchor (the page reloads at the grid).
   ============================================================ */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function words(value) {
    return (value || '').split(/\s+/).filter(Boolean);
  }

  function read(el, index) {
    return {
      el: el,
      index: index,
      who: words(el.getAttribute('data-gift-for')),
      cat: words(el.getAttribute('data-gift-cat')),
      price: parseInt(el.getAttribute('data-price'), 10) || 0,
      set: el.getAttribute('data-set') === 'true',
      rating: parseFloat(el.getAttribute('data-rating')) || 0
    };
  }

  function byRank(a, b) {
    if (b.rating !== a.rating) return b.rating - a.rating;
    if (a.price !== b.price) return a.price - b.price;
    return a.index - b.index;
  }

  function lowerFirst(text) {
    return text ? text.charAt(0).toLowerCase() + text.slice(1) : '';
  }

  function scrollTo(el) {
    if (!el) return;
    el.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
  }

  function focusQuietly(el) {
    if (!el) return;
    try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); }
  }

  function init(root) {
    if (!root || root.__luxeGg) return;
    root.__luxeGg = true;

    var finder = root.querySelector('[data-luxe-gg-finder]');
    if (!finder) return;

    var text = {};
    var textEl = root.querySelector('[data-luxe-gg-text]');
    if (textEl) {
      try { text = JSON.parse(textEl.textContent); } catch (e) { text = {}; }
    }

    var form = finder.querySelector('[data-luxe-gg-form]');
    var results = finder.querySelector('[data-luxe-gg-results]');
    var resultsHeading = finder.querySelector('[data-luxe-gg-results-heading]');
    var picksEl = finder.querySelector('[data-luxe-gg-picks]');
    var whyEl = finder.querySelector('[data-luxe-gg-why]');
    var setEl = finder.querySelector('[data-luxe-gg-set]');
    var finderHeading = finder.querySelector('[data-luxe-gg-finder-heading]');
    var finderTile = root.querySelector('[data-luxe-gg-finder-tile]');
    var low = parseInt(finder.getAttribute('data-low'), 10) || 0;
    var high = parseInt(finder.getAttribute('data-high'), 10) || 0;

    var items = Array.prototype.map.call(
      root.querySelectorAll('[data-luxe-gg-grid] [data-luxe-gg-item]'),
      read
    );

    function answer(q) {
      var input = form.querySelector('input[data-q="' + q + '"]:checked');
      return input || null;
    }

    function inBudget(item, spend) {
      if (spend === 'low') return item.price < low;
      if (spend === 'mid') return item.price >= low && item.price <= high;
      if (spend === 'high') return item.price > high;
      return true;
    }

    function pick(who, love, spend) {
      var pool = items.filter(function (i) { return !i.set; });
      var strict = pool.filter(function (i) {
        return (!who || i.who.indexOf(who) !== -1) &&
          (!love || love === 'any' || i.cat.indexOf(love) !== -1) &&
          inBudget(i, spend);
      }).sort(byRank);
      var chosen = strict.slice(0, 2);
      var tier = 'match';

      if (chosen.length < 2) {
        tier = 'budget';
        pool.filter(function (i) { return inBudget(i, spend) && chosen.indexOf(i) === -1; })
          .sort(byRank)
          .forEach(function (i) { if (chosen.length < 2) chosen.push(i); });
      }
      if (chosen.length < 2) {
        tier = 'best';
        pool.forEach(function (i) { if (chosen.length < 2 && chosen.indexOf(i) === -1) chosen.push(i); });
      }

      // The set: same person and category, else same person, else any set.
      var sets = items.filter(function (i) { return i.set; });
      var forWho = sets.filter(function (i) { return !who || i.who.indexOf(who) !== -1; }).sort(byRank);
      var forBoth = forWho.filter(function (i) { return !love || love === 'any' || i.cat.indexOf(love) !== -1; });
      var set = forBoth[0] || forWho[0] || sets.slice().sort(byRank)[0] || null;

      return { picks: chosen, set: set, tier: tier };
    }

    function phraseFor(input, q) {
      if (input) {
        if (q === 'who') return input.getAttribute('data-phrase') || '';
        var label = input.nextElementSibling;
        return lowerFirst(label ? label.textContent.trim() : '');
      }
      var fieldset = form.querySelector('input[data-q="' + q + '"]');
      fieldset = fieldset ? fieldset.closest('fieldset') : null;
      return fieldset ? fieldset.getAttribute('data-any-phrase') || '' : '';
    }

    function cloneCard(item) {
      var copy = item.el.cloneNode(true);
      copy.removeAttribute('data-luxe-gg-item');
      copy.removeAttribute('id');
      Array.prototype.forEach.call(copy.querySelectorAll('img[loading="lazy"]'), function (img) {
        img.setAttribute('loading', 'eager');
      });
      return copy;
    }

    function fillSet(set) {
      if (!setEl) return;
      if (!set) { setEl.hidden = true; return; }
      var pic = setEl.querySelector('[data-luxe-gg-set-pic]');
      var meta = setEl.querySelector('[data-luxe-gg-set-meta]');
      var link = setEl.querySelector('[data-luxe-gg-set-link]');
      var name = setEl.querySelector('[data-luxe-gg-set-name]');
      var el = set.el;
      var title = el.getAttribute('data-title') || '';
      var worth = el.getAttribute('data-worth-label');
      var parts = [title];
      if (worth) parts.push((text.worth || 'Worth') + ' ' + worth);
      parts.push(el.getAttribute('data-price-label') || '');
      if (pic) {
        pic.textContent = '';
        if (el.getAttribute('data-img')) {
          var img = document.createElement('img');
          img.className = 'luxe-gg__set-img';
          img.alt = '';
          img.width = 72;
          img.height = 72;
          img.src = el.getAttribute('data-img');
          pic.appendChild(img);
        }
      }
      if (meta) meta.textContent = parts.filter(Boolean).join(' · ');
      if (link) link.href = el.getAttribute('data-url') || link.href;
      if (name) name.textContent = ' ' + title;
      setEl.hidden = false;
    }

    function show() {
      var whoInput = answer('who');
      var loveInput = answer('love');
      var spendInput = answer('spend');
      var result = pick(
        whoInput ? whoInput.value : '',
        loveInput ? loveInput.value : '',
        spendInput ? spendInput.value : ''
      );

      picksEl.textContent = '';
      result.picks.forEach(function (item) { picksEl.appendChild(cloneCard(item)); });

      var template = result.tier === 'match' ? text.whyMatch : result.tier === 'budget' ? text.whyBudget : text.whyBest;
      whyEl.textContent = (template || '')
        .replace('{who}', phraseFor(whoInput, 'who'))
        .replace('{budget}', phraseFor(spendInput, 'spend'));
      whyEl.hidden = !whyEl.textContent;

      fillSet(result.set);

      form.hidden = true;
      results.hidden = false;
      scrollTo(finder);
      focusQuietly(resultsHeading);
    }

    function reset() {
      form.reset();
      results.hidden = true;
      picksEl.textContent = '';
      form.hidden = false;
      scrollTo(finder);
      focusQuietly(form.querySelector('input'));
    }

    function open(event) {
      if (event) event.preventDefault();
      finder.classList.remove('luxe-gg__finder--collapsed');
      if (finderTile) finderTile.hidden = true;
      scrollTo(finder);
      focusQuietly(finderHeading);
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      show();
    });

    var again = finder.querySelector('[data-luxe-gg-again]');
    if (again) again.addEventListener('click', reset);

    Array.prototype.forEach.call(root.querySelectorAll('[data-luxe-gg-open]'), function (link) {
      link.addEventListener('click', open);
    });
  }

  function initAll(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-luxe-gg]'), init);
  }

  initAll(document);
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
